<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  secondsRemaining: {
    type: Number,
    required: true,
  },
  totalSeconds: {
    type: Number,
    required: true,
  },
  needsManualRefresh: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['refresh']);

const { t } = useI18n();

const percentRemaining = computed(() => {
  const percent = (props.secondsRemaining / props.totalSeconds) * 100;
  return Math.max(0, Math.min(100, percent));
});
</script>

<template>
  <div class="flex flex-col items-center gap-2 w-full max-w-[14rem]">
    <NextButton
      v-if="needsManualRefresh"
      faded
      slate
      xs
      :is-loading="isLoading"
      :label="t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION.QR.REGENERATE')"
      @click="emit('refresh')"
    />
    <template v-else>
      <div class="h-1 w-full rounded-full overflow-hidden bg-n-slate-4">
        <div
          class="h-1 bg-n-blue-9 transition-all duration-1000 ease-linear"
          :style="{ width: `${percentRemaining}%` }"
        />
      </div>
      <p class="text-xs text-n-slate-10">
        {{
          t('INBOX_MGMT.ADD.WHATSAPP.EVOLUTION.QR.AUTO_REFRESH_IN', {
            seconds: secondsRemaining,
          })
        }}
      </p>
    </template>
  </div>
</template>
